import React, { Fragment, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import {
  get_request_list,
  update_payment_status,
  get_refund_list,
  update_refund_status,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import { SITENAMEALIAS } from "../utils/init";
import {
  showToast,
  showHttpError,
  _isOnlyNumber,
  currentPageAccess,
  showConfirm,
} from "../utils/library";
import "../assets/css/style.css";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";

const rs = {
  pageWrapper: {
    padding: "36px 24px 60px",
    overflow: "hidden",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  },
  btnIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "38px",
    height: "38px",
    background: "var(--body-color-less)",
    border: "1px solid var(--body-color-less2)",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "var(--text-color)",
    fontSize: "14px",
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  filterBtn: (isActive) => ({
    padding: "7px 20px",
    fontSize: "13px",
    fontWeight: "600",
    borderRadius: "8px",
    border: isActive ? "none" : "1px solid var(--body-color-less2)",
    background: isActive ? "var(--btn-color)" : "transparent",
    color: isActive ? "#fff" : "var(--text-color)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    opacity: isActive ? 1 : 0.7,
    whiteSpace: "nowrap",
  }),
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  tableWrapper: {
    overflowX: "auto",
    maxWidth: "100%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "14px 16px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left",
    whiteSpace: "nowrap",
    background: "var(--body-color-less)",
  },
  td: {
    padding: "14px 16px",
    fontSize: "13px",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  tdEllipsis: {
    padding: "14px 16px",
    fontSize: "13px",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "180px",
    cursor: "default",
  },
  invoiceChip: {
    fontFamily: "monospace",
    fontSize: "12px",
    padding: "3px 8px",
    background: "var(--body-color-less2)",
    borderRadius: "6px",
  },
  actionBtn: (color) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    background:
      color === "red"
        ? "rgba(239,68,68,0.1)"
        : color === "green"
        ? "rgba(16,185,129,0.1)"
        : "var(--body-color-less2)",
    color:
      color === "red"
        ? "#ef4444"
        : color === "green"
        ? "#10b981"
        : "var(--text-color)",
    fontSize: "14px",
    marginRight: "6px",
  }),
  emptyState: {
    padding: "60px 20px",
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: "48px",
    opacity: 0.15,
    marginBottom: "16px",
  },
  emptyText: {
    fontSize: "14px",
    opacity: 0.4,
    fontWeight: "500",
  },
  // Modal styles
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1050,
  },
  modalCard: {
    background: "var(--body-color)",
    borderRadius: "16px",
    width: "440px",
    maxWidth: "90vw",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    overflow: "hidden",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    margin: 0,
  },
  modalClose: {
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    border: "none",
    background: "var(--body-color-less2)",
    cursor: "pointer",
    fontSize: "18px",
    color: "var(--text-color)",
    opacity: 0.6,
  },
  modalBody: {
    padding: "24px",
  },
  modalLabel: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    opacity: 0.7,
    marginBottom: "6px",
    display: "block",
  },
  modalInput: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    marginBottom: "16px",
  },
  modalRequestedBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 90%), color-mix(in srgb, var(--btn-color), transparent 95%))",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: "20px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
  },
  modalFooter: {
    display: "flex",
    gap: "10px",
    padding: "0 24px 24px",
  },
  btnRefund: {
    flex: 1,
    padding: "11px 20px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnRefundFull: {
    flex: 1,
    padding: "11px 20px",
    background: "#10b981",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
  tooltip: {
    position: "relative",
  },
};

class RecurringPaymentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSubscription: [],
      canceledSubscription: [],
      outstandingSubscription: [],
      requestedSubscription: [],
      refundSubscription: [],
      subscriptionType: "active",
      refundModalOpen: false,
      selectedInvoiceId: null,
      requestedRefundAmount: null,
      refundAmountInput: null,
      selectedCurrencyCode: "",
      permission: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      permission: currentPageAccess(),
    });
    this.handleSubscriptionType("active");
    this.getRequestList();
    this.getRefundList();
  }

  handleSubscriptionType = (param) => {
    this.setState({
      subscriptionType: param,
    });
  };

  getRequestList = () => {
    let payload = {
      merchant_uuid: getAuthUuid(),
    };
    this.setState({ showLoader: true });
    get_request_list(payload)
      .then(
        function (res) {
          let response = res.data[0];
          console.log("responseeeee", response);
          this.setState({ showLoader: false });
          if (response.error !== 0) {
            showToast("error", response.error_msg);
          } else {
            let activeArr = [];
            let canceledArr = [];
            let outstandingArr = [];
            let requestedArr = [];

            let requestList = response?.request_list || [];
            for (let i = 0; i < requestList.length; i++) {
              let obj = {
                customerName: requestList[i].customer_name,
                customerEmail: requestList[i].customer_email,
                invoiceId: requestList[i].id,
                amount: requestList[i].amount,
                recurringPeriod: requestList[i].recurring_period,
                outstandingAmount: requestList[i].outstanding_amount,
                startDate: requestList[i].start_date,
                endDate: requestList[i].end_date,
                nextBillingCycleDate: requestList[i].next_billing_date,
                status: requestList[i].description,
                currencyCode: requestList[i].currency_code,
              };

              if (requestList[i].status === 1) {
                activeArr.push(obj);
              } else if (requestList[i].status === 2) {
                canceledArr.push(obj);
              } else if (requestList[i].status === 0) {
                requestedArr.push(obj);
              }
            }
            this.setState({
              activeSubscription: activeArr,
              canceledSubscription: canceledArr,
              outstandingSubscription: outstandingArr,
              requestedSubscription: requestedArr,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  getRefundList = () => {
    let payload = {
      merchant_uuid: getAuthUuid(),
    };
    this.setState({ showLoader: true });
    get_refund_list(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let refundArr = [];
            for (let i = 0; i < response?.data?.length; i++) {
              let obj = {
                customerName: response.data[i].customer_name,
                customerEmail: response.data[i].customer_email,
                invoiceId: response.data[i].id,
                requestedAmount: response.data[i].requested_amount,
                refundAmount: response.data[i].refund_amount,
                recurringPeriod: response.data[i].recurring_period,
                startDate: response.data[i].start_date,
                nextBillingCycleDate: response.data[i].next_billing_cycle,
                status: response.data[i].description,
                currencyCode: response.data[i].currency_code,
                refundStatusValue: response.data[i].refund_status,
              };
              refundArr.push(obj);
            }
            this.setState({
              refundSubscription: refundArr,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  reload = () => {
    this.getRequestList();
    this.getRefundList();
  };

  updateStatus = (id, statusCode) => {
    let payload = {
      merchant_uuid: getAuthUuid(),
      status: statusCode,
      id: id,
    };
    this.setState({ showLoader: true });
    update_payment_status(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            setTimeout(() => {
              this.getRequestList();
            }, 2000);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  updateRefundStatus = (id, refundAmount, statusCode) => {
    if (refundAmount <= 0) {
      showToast("error", "Refund amount must be greater than 0");
      return;
    } else if (refundAmount > this.state.requestedRefundAmount) {
      showToast("error", "Refund amount must be lesser than requested amount");
      return;
    } else {
      let payload = {
        merchant_uuid: getAuthUuid(),
        status: statusCode,
        amount: Number(refundAmount),
        id: id,
      };
      this.setState({ showLoader: true });
      update_refund_status(payload)
        .then(
          function (res) {
            let response = res.data[0];
            this.setState({ showLoader: false });
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.error_msg);
              this.setState({
                selectedInvoiceId: null,
                requestedRefundAmount: null,
                refundModalOpen: false,
                refundAmountInput: null,
                selectedCurrencyCode: "",
              });
              setTimeout(() => {
                this.getRefundList();
              }, 2000);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  rejectRefund = (id, refundAmount, statusCode) => {
    let payload = {
      merchant_uuid: getAuthUuid(),
      status: statusCode,
      amount: Number(refundAmount),
      id: id,
    };
    this.setState({ showLoader: true });
    update_refund_status(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            setTimeout(() => {
              this.getRefundList();
            }, 2000);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  openRefundModal = (id, requestedAmount, currencyCode) => {
    this.setState({
      selectedInvoiceId: id,
      requestedRefundAmount: requestedAmount,
      refundModalOpen: true,
      selectedCurrencyCode: currencyCode,
    });
  };

  closeRefundModal = () => {
    this.setState({
      selectedInvoiceId: null,
      requestedRefundAmount: null,
      refundModalOpen: false,
      refundAmountInput: null,
      selectedCurrencyCode: "",
    });
  };

  handleChange = (event) => {
    var { name, value } = event.target;
    if (_isOnlyNumber(value)) {
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: "" });
    }
  };

  renderEmptyState = (text) => (
    <div style={rs.emptyState}>
      <div style={rs.emptyIcon}>
        <i className="fas fa-file-invoice"></i>
      </div>
      <p style={rs.emptyText}>{text}</p>
    </div>
  );

  renderTable = (columns, data, renderRow) => (
    <div style={rs.tableWrapper}>
      <table style={rs.table}>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i} style={rs.th}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map(renderRow)}</tbody>
      </table>
      {data?.length === 0 && this.renderEmptyState("No records found")}
    </div>
  );

  render() {
    const filters = [
      { key: "active", label: "Active Subscriptions", icon: "fa-circle-play" },
      { key: "canceled", label: "Canceled", icon: "fa-circle-xmark" },
      { key: "requested", label: "Payment Requests", icon: "fa-clock" },
      { key: "refund", label: "Refund Requests", icon: "fa-rotate-left" },
    ];

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={rs.pageWrapper}>
              {/* Page Header */}
              <div style={rs.headerRow}>
                <PageHeader
                  icon="mdi-autorenew"
                  title="Subscriptions"
                  subtitle="Manage subscriptions, payment requests, and refunds"
                />
                <div style={rs.headerActions}>
                  <button
                    style={rs.btnIcon}
                    type="button"
                    onClick={() => this.reload()}
                    title="Reload"
                  >
                    <i className="fas fa-arrows-rotate"></i>
                  </button>
                  <button
                    style={rs.btnPrimary}
                    type="button"
                    onClick={() =>
                      this.props.history.push("/request-recurring-payment")
                    }
                  >
                    <i className="fas fa-plus" style={{ fontSize: "12px" }}></i>
                    Create Subscription
                  </button>
                </div>
              </div>

              {/* Filter Tabs */}
              <div style={rs.filterBar}>
                {filters.map((f) => (
                  <button
                    key={f.key}
                    type="button"
                    style={rs.filterBtn(this.state.subscriptionType === f.key)}
                    onClick={() => this.handleSubscriptionType(f.key)}
                  >
                    {f.label}
                  </button>
                ))}
              </div>

              {/* Table Card */}
              <div style={rs.card}>
                {/* Active Subscriptions */}
                {this.state.subscriptionType === "active" &&
                  this.renderTable(
                    [
                      "Customer",
                      "Email",
                      "Invoice ID",
                      "Amount",
                      "Period",
                      "Outstanding",
                      "Start Date",
                      "Next Billing",
                      "Description",
                      "Action",
                    ],
                    this.state.activeSubscription,
                    (item) => (
                      <tr key={item.invoiceId}>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.customerName}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.customerEmail}
                        </td>
                        <td style={rs.td}>
                          <span style={rs.invoiceChip}>{item.invoiceId}</span>
                        </td>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.amount} USD
                        </td>
                        <td style={rs.td}>{item.recurringPeriod}</td>
                        <td style={rs.td}>
                          {item.outstandingAmount} {item.currencyCode}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.startDate}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.nextBillingCycleDate}
                        </td>
                        <td style={rs.tdEllipsis} title={item.status}>
                          {item.status}
                        </td>
                        <td style={rs.td}>
                          <button
                            style={rs.actionBtn("red")}
                            onClick={() =>
                              showConfirm(
                                "Stop Recurring Payment",
                                "Are you sure you want to stop this recurring payment?",
                                "warning",
                                () => this.updateStatus(item.invoiceId, 2)
                              )
                            }
                            disabled={this.state.permission !== "WRITE"}
                            title="Stop Recurring Payment"
                          >
                            <i className="fas fa-ban"></i>
                          </button>
                        </td>
                      </tr>
                    )
                  )}

                {/* Canceled Subscriptions */}
                {this.state.subscriptionType === "canceled" &&
                  this.renderTable(
                    [
                      "Customer",
                      "Email",
                      "Invoice ID",
                      "Amount",
                      "Period",
                      "Outstanding",
                      "Start Date",
                      "End Date",
                      "Description",
                    ],
                    this.state.canceledSubscription,
                    (item) => (
                      <tr key={item.invoiceId}>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.customerName}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.customerEmail}
                        </td>
                        <td style={rs.td}>
                          <span style={rs.invoiceChip}>{item.invoiceId}</span>
                        </td>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.amount} USD
                        </td>
                        <td style={rs.td}>{item.recurringPeriod}</td>
                        <td style={rs.td}>
                          {item.outstandingAmount} {item.currencyCode}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.startDate}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.endDate}
                        </td>
                        <td style={rs.tdEllipsis} title={item.status}>
                          {item.status}
                        </td>
                      </tr>
                    )
                  )}

                {/* Requested Subscriptions */}
                {this.state.subscriptionType === "requested" &&
                  this.renderTable(
                    [
                      "Customer",
                      "Email",
                      "Invoice ID",
                      "Amount",
                      "Period",
                      "Start Date",
                      "Next Billing",
                      "Description",
                      "Action",
                    ],
                    this.state.requestedSubscription,
                    (item) => (
                      <tr key={item.invoiceId}>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.customerName}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.customerEmail}
                        </td>
                        <td style={rs.td}>
                          <span style={rs.invoiceChip}>{item.invoiceId}</span>
                        </td>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.amount} USD
                        </td>
                        <td style={rs.td}>{item.recurringPeriod}</td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.startDate}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.nextBillingCycleDate}
                        </td>
                        <td style={rs.tdEllipsis} title={item.status}>
                          {item.status}
                        </td>
                        <td style={rs.td}>
                          <button
                            style={rs.actionBtn("red")}
                            onClick={() =>
                              showConfirm(
                                "Decline Recurring Payment",
                                "Are you sure you want to decline this recurring payment?",
                                "warning",
                                () => this.updateStatus(item.invoiceId, 2)
                              )
                            }
                            disabled={this.state.permission !== "WRITE"}
                            title="Decline Recurring Payment"
                          >
                            <i className="fas fa-ban"></i>
                          </button>
                        </td>
                      </tr>
                    )
                  )}

                {/* Refund Requests */}
                {this.state.subscriptionType === "refund" &&
                  this.renderTable(
                    [
                      "Customer",
                      "Email",
                      "Invoice ID",
                      "Requested Amt",
                      "Refund Amt",
                      "Period",
                      "Start Date",
                      "Next Billing",
                      "Description",
                      "Actions",
                    ],
                    this.state.refundSubscription,
                    (item) => (
                      <tr key={item.invoiceId}>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.customerName}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.customerEmail}
                        </td>
                        <td style={rs.td}>
                          <span style={rs.invoiceChip}>{item.invoiceId}</span>
                        </td>
                        <td style={{ ...rs.td, fontWeight: "600" }}>
                          {item.requestedAmount} {item.currencyCode}
                        </td>
                        <td style={rs.td}>
                          {item.refundAmount} {item.currencyCode}
                        </td>
                        <td style={rs.td}>{item.recurringPeriod}</td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.startDate}
                        </td>
                        <td style={{ ...rs.td, opacity: 0.7 }}>
                          {item.nextBillingCycleDate}
                        </td>
                        <td style={rs.tdEllipsis} title={item.status}>
                          {item.status}
                        </td>
                        <td style={rs.td}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <button
                              style={rs.actionBtn("green")}
                              onClick={() =>
                                this.openRefundModal(
                                  item.invoiceId,
                                  item.requestedAmount,
                                  item.currencyCode
                                )
                              }
                              disabled={
                                item.refundStatusValue > 1 &&
                                this.state.permission === "READ"
                              }
                              title={
                                item.refundStatusValue === 1
                                  ? "Accept Refund"
                                  : ""
                              }
                            >
                              <i className="fas fa-check"></i>
                            </button>
                            <button
                              style={rs.actionBtn("red")}
                              onClick={() =>
                                showConfirm(
                                  "Reject Refund",
                                  "Are you sure you want to reject this refund request?",
                                  "warning",
                                  () =>
                                    this.rejectRefund(
                                      item.invoiceId,
                                      item.requestedAmount,
                                      3
                                    )
                                )
                              }
                              disabled={
                                item.refundStatusValue > 1 &&
                                this.state.permission === "READ"
                              }
                              title={
                                item.refundStatusValue === 1
                                  ? "Reject Refund"
                                  : ""
                              }
                            >
                              <i className="fas fa-xmark"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  )}
              </div>
            </div>

            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>

        {/* Refund Modal */}
        <Modal
          show={this.state.refundModalOpen}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={rs.modalHeader}>
            <h3 style={rs.modalTitle}>Process Refund</h3>
            <button
              type="button"
              style={rs.modalClose}
              onClick={this.closeRefundModal}
            >
              <i className="fas fa-xmark"></i>
            </button>
          </div>
          <div style={rs.modalBody}>
            <div style={rs.modalRequestedBadge}>
              <i
                className="fas fa-circle-info"
                style={{ color: "var(--btn-color)", fontSize: "14px" }}
              ></i>
              <span>
                Requested:{" "}
                <strong>
                  {this.state.requestedRefundAmount}{" "}
                  {this.state.selectedCurrencyCode}
                </strong>
              </span>
            </div>

            <label style={rs.modalLabel}>Refund Amount</label>
            <input
              type="text"
              style={rs.modalInput}
              name="refundAmountInput"
              value={
                this.state.refundAmountInput === null
                  ? ""
                  : this.state.refundAmountInput
              }
              onChange={this.handleChange}
              placeholder="Enter amount to refund"
            />
          </div>
          <div style={rs.modalFooter}>
            <button
              type="button"
              style={{
                ...rs.btnRefund,
                ...(this.state.refundAmountInput === null
                  ? rs.btnDisabled
                  : {}),
              }}
              disabled={this.state.refundAmountInput === null}
              onClick={() =>
                this.updateRefundStatus(
                  this.state.selectedInvoiceId,
                  this.state.refundAmountInput,
                  2
                )
              }
            >
              Refund Custom Amount
            </button>
            <button
              type="button"
              style={rs.btnRefundFull}
              onClick={() =>
                this.updateRefundStatus(
                  this.state.selectedInvoiceId,
                  this.state.requestedRefundAmount,
                  2
                )
              }
            >
              Refund Full Amount
            </button>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(RecurringPaymentList);
